import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { RouterModule } from '@angular/router';
import { HomeRoutingModule } from './home-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MailingListModule } from '../mailing-list/mailing-list.module';
import { FaIconModule } from '../shared/modules/fa-icon/fa-icon.module';
import { YouTubePlayerModule } from '@angular/youtube-player';



@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    FormsModule,
    FaIconModule,
    MailingListModule,
    ReactiveFormsModule,
    YouTubePlayerModule,
    RouterModule
  ]
})
export class HomeModule { }
